import { Money } from "src/modules/types"

// Calculate the earnings from rates.
// rate is in whole decimal numbers, e.g. 1.5% = 1.5;
// Returns an array with 15 measure points, one for each year 0 - 15.

function noInterest(rate: any, principal: Money, monthlyAmount: Money, compoundPeriod: any, years: number) {
    return principal + (monthlyAmount * 12 * years)
}

function compoundInterest(rate: number, principal: Money, monthlyAmount: Money, compoundPeriod: number, years: number) {

    const n = years * compoundPeriod
    const f = Math.pow((1 + rate), n)
    const value = principal * f + monthlyAmount * ((f - 1) / rate)
    return value
}

export function calculateIncomeFromRate(rate: number, principal: Money, monthlyAmount: Money, period: number, maxYears: number, reinvest = true): {
    x: number
    y: number
}[] {
    let rateFunction = compoundInterest
    if (rate == 0.0) {
        rateFunction = noInterest
    }

    if (!reinvest && rate != 0.0)
    {
    // For no reinvest do a different calculation.
        const perMonth = calculateSimpleEarnings(principal, rate, monthlyAmount, (period * 12))

        const perYear = []
        for (let i = 0; i <= maxYears; i++) {
            const index = i * 12
            perYear.push({ x: i, y: perMonth[index] })
        }
        return perYear
    }
    else
    {
    // Calculate for each year.
        const values = []

        const compoundPeriod = 12 // We always run on a 12 month per year compound period.
        rate = rate / 100.0 / compoundPeriod

        for (let i = 0; i <= maxYears; i++) {
            const value = rateFunction(rate, principal, monthlyAmount, compoundPeriod, i)
            values.push({ x: i, y: Math.round(value) })
        }
        return values
    }
}

function calculateEMI(amount: Money, rate: number, period: number) {
    const frac = rate / 12.0 / 100.0
    const emi = (1 / Math.pow(1 + frac, period))
    return (amount * frac) / (1 - emi)
}

function calculateSimpleEarnings(amount1: Money, rate: number, monthly: Money, period: number) {
    const emi1 = calculateEMI(amount1, rate, period)
    const timeLeft = 180.0 // Always run up to 15 years.

    const emi = [emi1]
    const amount = [amount1]

    return [amount1].concat(calSimpEarRec(amount, rate, emi, monthly, period, timeLeft, amount1, 0))
}

// Recursive function to create an array of investment value, one index per month.
function calSimpEarRec(amount: Money[], rate: number, emi: Money[], monthly: Money, period: any, timeLeft: number, value: Money, n: number) {
    if (n >= timeLeft) return []
    const frac = rate / 12.0 / 100.0

    for (let i = 0; i < amount.length; i++) {
        const interest = amount[i] * frac
        // subtract to find out whats left in "invested"
        amount[i] = amount[i] - (emi[i] - interest)
        // add to the current value of the stock
        if (interest > 0) {
            value += interest
        }
    }

    // add the monthly deposit
    if (monthly > 0) {
        amount.push(monthly)
        emi.push(calculateEMI(monthly, rate, period))
        value += monthly
    }

    // push value and recurse
    return [value].concat(calSimpEarRec(amount, rate, emi, monthly, period, timeLeft, value, n + 1))
}


